import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CustomIcon from '../../common/CustomIcon';
import * as bookActions from '../../../actions/bookActions';
import * as translateService from '../../../services/translate/customTranslateService';
import SanitizedString from '../../common/SanitizedString';

class ActivityItem extends Component {
  static propTypes = {
    user: PropTypes.any,
    book: PropTypes.any,
    classroom: PropTypes.any,
    institution: PropTypes.any,
    bookActions: PropTypes.any,
    contentSynchronizationStatus: PropTypes.any,
    withResults: PropTypes.any,
    activity: PropTypes.any,
    activityIcon: PropTypes.any,
    index: PropTypes.any,
    openActivity: PropTypes.func,
    isTeacher: PropTypes.bool,
    lesson: PropTypes.object
  };

  constructor(context, props) {
    super(context, props);
    this.getIconGrade = this.getIconGrade.bind(this);
  }

  //--------------------------------------------------------------------------------------------------------------------
  getIconGrade() {
    const { isTeacher, activity } = this.props;
    let success = activity.success;
    // ToDo: this commentswill be uncommented when the links to activities are enabled

    if (success === null) {
      // let text = isTeacher ?
      //   I18n.t('panels.assignment.evaluate') :
      //   <CustomIcon name="question-mark-circle" size={24} />;
      let className = isTeacher ? 'evaluate' : 'pending';
      return (
        // <div onClick={() => openActivity(activity.activityId)} className={className}>
        <div className={className}>
          {/* {text} */}
          <CustomIcon name="question-mark-circle" size={24} />
        </div>
      );
    }

    if (success === true) {
      return (
        // <div onClick={() => openActivity(activity.activityId)} className="success">
        <div className="success">
          <CustomIcon name="checking-mark-circle" size={24} />
        </div>
      );
    }

    if (success === false) {
      return (
        // <div onClick={() => openActivity(activity.activityId)} className="failed">
        <div className="failed">
          <CustomIcon name="cancel-button" size={24} />
        </div>
      );
    }

    if (success === undefined) {
      return (
        // <div onClick={() => openActivity(activity.activityId)} className="answer">
        <div className="answer">{/* {isTeacher ? <div/> : I18n.t('panels.assignment.answer')} */}</div>
      );
    }
  }

  //--------------------------------------------------------------------------------------------------------------------
  render() {
    const { withResults, activity, activityIcon, index, openActivity, lesson } = this.props;

    return (
      <div
        className="activity-grades-container indented"
        key={activity.activityId + index}
        onClick={() => openActivity(lesson.activityId, activity.activityId)}
      >
        <span>
          <CustomIcon name={activityIcon} size={24} />
        </span>
        <span className="ellipsis">
          <SanitizedString rawString={translateService.translateObject(activity.name)} />
        </span>

        {withResults ? this.getIconGrade() : undefined}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    book: state.book.book,
    user: state.account.user,
    institution: state.school.school,
    contentSynchronizationStatus: state.content.contentSynchronizationStatus
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityItem);
